<template>
	<div>
		<el-divider></el-divider>
		<span style="text-align:left;">地域常用性</span>
		<el-row v-for="(val, key) in data" :key="key">
			<el-col :span="2" style="text-align:right;line-height:28px;">
				{{key}}
			</el-col>
			<el-col :span="22">
				<el-form
				 label-position="right"
				 label-width="110px"
				>
					<el-form-item v-for="city in val" :key="city.areaName" :label="city.areaName" style="maring-bottom:10px">
						<el-switch
						 v-model="city.valueDictValue"
						 active-color="#13ce66"
						 :active-value="1"
						 :inactive-value="0"
						 @change="(nval)=>areaChange(nval,city)"
						>
						</el-switch>
						<span style="font-size:12px;display:inline-block;margin-left:12px">{{city.valueDictValue==1?'常用':'不常用'}}</span>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: "ApplyArea",
	props: {
		data: {
			type: Object
		}
	},
	data(){
		return {
		}
	},
	methods: {
		areaChange(nval,city) {
			this.$emit('areaChange',nval,city);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/applyarea.vue